exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-container[data-v-1fbfe4e1]{position:relative}.input-field[data-v-1fbfe4e1]{border:1px solid #dce2ed;background-color:#fff;color:#808fa4;font-family:Open Sans,sans-serif;font-size:16px;letter-spacing:0;line-height:24px;padding:10px;width:100%}.suffix-padding[data-v-1fbfe4e1]{padding:10px 32px 10px 10px}.prefix-padding[data-v-1fbfe4e1]{padding:10px 10px 10px 32px}.input-suffix[data-v-1fbfe4e1]{position:absolute;top:12px;right:16px}.input-prefix[data-v-1fbfe4e1]{position:absolute;top:12px;left:16px}", ""]);

// exports
